import { SonarGlobalTimeout } from '../global/lib';
import { APP_TIMEOUTS, MOUSE_EVENTS } from '@sonar-software/sonar-ts-constants';

export function setIdleSessionTimeout(context: () => void): void {
	const sonarGlobalTimeout = new SonarGlobalTimeout(APP_TIMEOUTS.IDLE, context);
	const events = [
		MOUSE_EVENTS.CLICK,
		MOUSE_EVENTS.KEYPRESS,
		MOUSE_EVENTS.MOUSEDOWN,
		MOUSE_EVENTS.MOUSEMOVE
	];

	sonarGlobalTimeout.setTimeout();

	for (let i = 0; i < events.length; i += 1) {
		const event = events[ i ];

		document.addEventListener(event, () => {
			sonarGlobalTimeout.clearTimeout();
			sonarGlobalTimeout.setTimeout();
		});
	}
}
